module.exports = __webpack_public_path__ + "img/cage-count-icon.98af39aa.png";